'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeStorageOptionProperty = exports.getStorageOptions = exports.CHANGE_PROPERTY = exports.GET_STORAGEOPTIONS_TYPES = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.fetchStorageOptionsSaga = fetchStorageOptionsSaga;
exports.watchGetStorageOptions = watchGetStorageOptions;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _api = require('../../../helpers/api');

var _api2 = _interopRequireDefault(_api);

var _createFetchTypes = require('../../utils/createFetchTypes');

var _createFetchTypes2 = _interopRequireDefault(_createFetchTypes);

var _fetchEntitySagaAuth = require('../../utils/fetchEntitySagaAuth');

var _fetchEntitySagaAuth2 = _interopRequireDefault(_fetchEntitySagaAuth);

var _index = require('./index');

var _notifications = require('../notifications');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchStorageOptionsSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchGetStorageOptions);

var GET_STORAGEOPTIONS_TYPES = exports.GET_STORAGEOPTIONS_TYPES = (0, _createFetchTypes2.default)('tq-plus-admin/configuration/GET_STORAGEOPTIONS_TYPES');

var CHANGE_PROPERTY = exports.CHANGE_PROPERTY = 'tq-plus-admin/configuration/CHANGE_PROPERTY';

var initialState = {
  storageOptions: [],
  current: {}
};

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case GET_STORAGEOPTIONS_TYPES.REQUEST:
      return (0, _extends4.default)({}, state, { isLoading: true });
    case GET_STORAGEOPTIONS_TYPES.SUCCESS:
      return (0, _extends4.default)({}, state, {
        storageOptions: action.storageOptions
      });
    case GET_STORAGEOPTIONS_TYPES.FAILURE:
      return (0, _extends4.default)({}, state, { isLoading: false, error: action.error });
    case CHANGE_PROPERTY:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.field, action.value));
    case _index.GET_GENERICSETTINGS_TYPES.SUCCESS:
      return (0, _extends4.default)({}, state, action.genericSettings.configuration, {
        current: action.genericSettings.configuration
      });
    case _index.CANCEL:
      return (0, _extends4.default)({}, state, state.current);
    default:
      return state;
  }
}

// actions
var getStorageOptions = exports.getStorageOptions = {
  base: function base(codedToken) {
    return {
      type: GET_STORAGEOPTIONS_TYPES.BASE,
      url: 'generic-settings/get-storage-options',
      token: codedToken
    };
  },
  request: function request() {
    return { type: GET_STORAGEOPTIONS_TYPES.REQUEST };
  },
  success: function success(storageOptions) {
    return { type: GET_STORAGEOPTIONS_TYPES.SUCCESS, storageOptions: storageOptions };
  },
  failure: function failure(error) {
    return { type: GET_STORAGEOPTIONS_TYPES.FAILURE, error: error };
  }
};

var changeStorageOptionProperty = exports.changeStorageOptionProperty = function changeStorageOptionProperty(field, value) {
  return {
    type: CHANGE_PROPERTY, field: field, value: value
  };
};

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */
function fetchStorageOptionsSaga(_ref) {
  var url = _ref.url,
      token = _ref.token;
  var result;
  return _regenerator2.default.wrap(function fetchStorageOptionsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySagaAuth2.default)(getStorageOptions, _api2.default.get, url, { token: token });
          });

        case 3:
          result = _context.sent;
          return _context.abrupt('return', result);

        case 7:
          _context.prev = 7;
          _context.t0 = _context['catch'](0);
          _context.next = 11;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error retrieving storage options',
            message: _context.t0.message
          }));

        case 11:

          console.log(_context.t0);
          return _context.abrupt('return', _context.t0);

        case 13:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 7]]);
}

function watchGetStorageOptions() {
  return _regenerator2.default.wrap(function watchGetStorageOptions$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _reduxSaga.takeLatest)(GET_STORAGEOPTIONS_TYPES.BASE, fetchStorageOptionsSaga), 't0', 1);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/GenericSettings/configuration.js
// module id = 1655
// module chunks = 0